import classNames from 'classnames';
import React from 'react';

import { DiscountVariant } from '../../Blocks/DiscountVariant.csharp';
import { BestsellerProductInfoLabel } from './BestsellerProductInfoLabel';
import { NewProductInfoLabel } from './NewProductInfoLabel';
import { ProductInfoLabelProps } from './ProductInfoLabelProps.csharp';
import { VeganProductInfoLabel } from './VeganProductInfoLabel';

export const ProductInfoLabel: React.FunctionComponent<ProductInfoLabelProps> = (props) => {
    if (!props.showBestsellerLabel && !props.showVeganProductLabel && !props.showNewItemLabel && props.variant == DiscountVariant.Medium) return null;
    const showNewItemLabel = props.showNewItemLabel && !props.badgeSettings.hideNewItemLabel;
    const showBestsellerLabel = props.showBestsellerLabel && !props.badgeSettings.hideBestsellerLabel && !showNewItemLabel;
    const showVeganProductLabel = props.showVeganProductLabel && !props.badgeSettings.hideVeganLabel;

    const badges = [
        showNewItemLabel && <NewProductInfoLabel />,
        showBestsellerLabel && <BestsellerProductInfoLabel />,
        showVeganProductLabel && <VeganProductInfoLabel />
    ];

    const filteredBadges = badges.filter((b) => b !== false);

    return (
        <div
            className={classNames(
                props.variant == DiscountVariant.Medium ? 'Product__InfoLabel' : 'ProductCard__InfoLabel',
                !showBestsellerLabel &&
                    !showVeganProductLabel &&
                    !showNewItemLabel &&
                    props.variant != DiscountVariant.Medium &&
                    'ProductCard__InfoLabel--Empty'
            )}
        >
            {props.numberOfLabels > 0 ? filteredBadges.slice(0, props.numberOfLabels) : badges}
        </div>
    );
};
